import React from 'react';
import classNames from 'classnames';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  appBarSpacer: {
    minHeight: 48, // theme.mixins.toolbar to set minHeight as appBar height, but doesnt work when set as dense
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    height:'100vh',
    padding: theme.spacing.unit,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 9,
      padding: theme.spacing.unit * 3,
    },
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 30,
    },
  },
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  }
});

function AdminContentBox(props) {
  const { classes } = props;
  return (
    <main className={classNames(classes.content, {[classes.contentShift]: props.sideBarOpen})}>
      <div className={classes.appBarSpacer} />
      {props.children}
    </main>
  )
}

AdminContentBox.propTypes = {
  classes: PropTypes.object.isRequired,
  sideBarOpen: PropTypes.bool,
};

export default withStyles(styles)(AdminContentBox);
